var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragBalls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65625 6C9.76082 6 10.6562 5.10457 10.6562 4C10.6562 2.89543 9.76082 2 8.65625 2C7.55168 2 6.65625 2.89543 6.65625 4C6.65625 5.10457 7.55168 6 8.65625 6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65625 14C9.76082 14 10.6562 13.1046 10.6562 12C10.6562 10.8954 9.76082 10 8.65625 10C7.55168 10 6.65625 10.8954 6.65625 12C6.65625 13.1046 7.55168 14 8.65625 14Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65625 22C9.76082 22 10.6562 21.1046 10.6562 20C10.6562 18.8954 9.76082 18 8.65625 18C7.55168 18 6.65625 18.8954 6.65625 20C6.65625 21.1046 7.55168 22 8.65625 22Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6562 6C17.7608 6 18.6562 5.10457 18.6562 4C18.6562 2.89543 17.7608 2 16.6562 2C15.5517 2 14.6562 2.89543 14.6562 4C14.6562 5.10457 15.5517 6 16.6562 6Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6562 14C17.7608 14 18.6562 13.1046 18.6562 12C18.6562 10.8954 17.7608 10 16.6562 10C15.5517 10 14.6562 10.8954 14.6562 12C14.6562 13.1046 15.5517 14 16.6562 14Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6562 22C17.7608 22 18.6562 21.1046 18.6562 20C18.6562 18.8954 17.7608 18 16.6562 18C15.5517 18 14.6562 18.8954 14.6562 20C14.6562 21.1046 15.5517 22 16.6562 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragBalls);
export default __webpack_public_path__ + "static/media/drag-balls.fa158592.svg";
export { ForwardRef as ReactComponent };